import React from "react";
import { NavLink } from "react-router-dom";
import { usePlatformContext } from "../context/PlatformContext";
import { isAdminModuleEnabled } from "../config/features";
import { getPlatformRole, isAdminRole } from "../utils/platformRole";
import AdminNavigation from "../components/AdminNavigation";
import AdminAccessDenied from "../pages/admin/AdminAccessDenied";

export default function AdminLayout({ children, title }) {
  const { isLoading, status } = usePlatformContext();
  const role = getPlatformRole();
  const isAdmin = isAdminRole(role);

  if (isLoading || status === "missing" || status === "idle") {
    return (
      <div className="flex min-h-[60vh] items-center justify-center p-6">
        <div className="card w-full max-w-md p-6">
          <div className="h-4 w-32 animate-pulse rounded bg-slate-200" />
          <div className="mt-4 h-3 w-full animate-pulse rounded bg-slate-200" />
          <div className="mt-2 h-3 w-2/3 animate-pulse rounded bg-slate-200" />
          <div className="mt-6 h-10 w-full animate-pulse rounded bg-slate-200" />
        </div>
      </div>
    );
  }

  if (status === "error" || status === "forbidden" || status === "disabled") {
    return <AdminAccessDenied />;
  }

  if (!isAdminModuleEnabled({ role }) && !isAdmin) {
    return <AdminAccessDenied />;
  }

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="border-b border-slate-200 bg-white px-4 py-4">
        <div className="mx-auto flex w-full max-w-5xl items-center justify-between">
          <h1 className="text-xl font-semibold text-slate-900">
            {title || "Admin"}
          </h1>
          <NavLink
            className="text-sm text-amber-600"
            to="/dashboard"
            data-testid="admin-back-dashboard"
          >
            Back to dashboard
          </NavLink>
        </div>
      </header>
      <main className="mx-auto w-full max-w-5xl space-y-6 px-4 py-6">
        {isAdmin && (
          <div className="sticky top-2 z-10 lg:static">
            <AdminNavigation showBadges={false} />
          </div>
        )}
        {children}
      </main>
    </div>
  );
}
